import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const DryerSectionContainer = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  padding-bottom: ${({ theme }) => theme.token.paddingLG}px;

  .dryer-section-title {
    color: ${({ theme }) => theme.token.colorText};
    font-size: ${({ theme }) => theme.token.fontSizeLG}px;
    font-weight: 600;
    line-height: ${({ theme }) => theme.token.lineHeightLG};
    margin-bottom: ${({ theme }) => theme.token.marginLG}px;
  }

  .controls-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0;
  }

  .dryer-row {
    margin-bottom: ${({ theme }) => theme.token.marginLG}px;
    width: 100%;
    padding: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .dryer-form-item {
    margin: 0;
    width: 100%;
  }

  .dryer-select {
    width: 100%;
    height: 2.5rem;
    background: transparent;
    border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
    outline: 1px ${({ theme }) => theme.token.colorTextQuaternary} solid;
    outline-offset: -1px;
    border: none;
  }

  .add-dryer-button {
    width: 2.5rem;
    height: 2.5rem;
    padding: 0;
    background: transparent;
    border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
    outline: 1px ${({ theme }) => theme.token.colorTextQuaternary} solid;
    outline-offset: -1px;
    border: none;
  }

  .button-col {
    flex: 0 0 auto;
    padding-left: ${({ theme }) => theme.token.paddingXS}px;
  }
`;
